// import React from 'react'

// const ErrorHandlerUI = ({ error, resetErrorBoundary }) => {
//     return (
//         <div role="alert" style={{ padding: '20px', textAlign: 'center' }}>
//             <h2>Something went wrong:</h2>
//             <pre style={{ color: 'red' }}>{error.message}</pre>
//             <button onClick={resetErrorBoundary} style={{ margin: '10px' }}>Try Again</button>
//         </div>
//     );
// }

// export default ErrorHandlerUI




import React from 'react';
import { Grid, Typography, Button, Paper, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import ErrorImg from '../images/5206507.jpg'

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.background.default,
    },
    paper: {
        padding: theme.spacing(4),
        textAlign: 'center',
    },
    errorIcon: {
        fontSize: '4rem',
        color: theme.palette.error.main,
    },
    errorMessage: {
        color: theme.palette.error.main,
        marginBottom: theme.spacing(2),
    },
    image: {
        width: '100%',
        height: 'auto',
        maxWidth: '300px',
    },
    button: {
        marginTop: theme.spacing(2),
    },
}));

const ErrorHandlerUI = ({ error, resetErrorBoundary }) => {
    const classes = useStyles();

    const handleClearCachee = () => {
        // Clear the Cache Storage
        console.log("Clear Cache btn clicked")
        if ('caches' in window) {
            caches.keys().then((keyList) => {
                return Promise.all(keyList.map((key) => caches.delete(key)));
            }).then(() => {
                console.log('Cache storage cleared.');
            }).catch((err) => {
                console.error('Error clearing cache storage:', err);
            });
        }

        // // Clear localStorage
        // localStorage.clear();
        // console.log('Local storage cleared.');

        // // Clear sessionStorage
        // sessionStorage.clear();
        // console.log('Session storage cleared.');

        // Optionally, you can also reload the page
        window.location.reload();
    };


    return (
        <div className={classes.root}>
            <Paper className={classes.paper} elevation={3}>
                <Grid container spacing={3}>
                    {/* Left side: Error message and button */}
                    <Grid item xs={12} md={6}>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <ErrorOutlineIcon className={classes.errorIcon} />
                            <Typography variant="h5" className={classes.errorMessage}>
                                Something went wrong
                            </Typography>
                            <Typography variant="body1">
                                {error.message}
                            </Typography>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={resetErrorBoundary}
                                className={classes.button}
                            >
                                Try Again
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                // onClick={resetErrorBoundary}
                                onClick={handleClearCachee}
                                className={classes.button}
                            >
                                Reload
                            </Button>
                        </Box>
                    </Grid>

                    {/* Right side: Error image */}
                    <Grid item xs={12} md={6}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <img
                                src={ErrorImg} // Replace with your error image URL
                                alt="Error"
                                className={classes.image}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
};

export default ErrorHandlerUI;
